//imports
import {
    ACTIVITIES_TAB_SEARCH_REQUEST,
    ACTIVITIES_TAB_SEARCH_RESULT,
    ACTIVITIES_TAB_SEARCH_USERS_REQUEST,
    ACTIVITIES_TAB_SEARCH_USERS_RESULT,
    ACTIVITIES_TAB_SEARCH_OPEN_MODAL,
    ACTIVITIES_TAB_SEARCH_CLOSE_MODAL,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_INSTANCE_STATE = {
    loading: false,
    activities: [],
    nextToken: null,
    entityName: null,
    entityId: null,
    companyId: null
};

const INIT_STATE = {
    instances: {},
    users: [],
    loadingUsers: false,
    openModal: false,
    modalInstanceId: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case ACTIVITIES_TAB_SEARCH_OPEN_MODAL: {
            const { instanceId, data, companyId } = action.payload;
            return {
                ...state,
                openModal: true,
                modalInstanceId: instanceId,
                instances: {
                    ...state.instances,
                    [instanceId]: {
                        ...(state.instances[instanceId] || INIT_INSTANCE_STATE),
                        entityName: data.entityName,
                        entityId: data.entityId,
                        companyId: companyId
                    }
                }
            };
        }
        case ACTIVITIES_TAB_SEARCH_CLOSE_MODAL:
            return { ...state, openModal: false, modalInstanceId: null };

        case ACTIVITIES_TAB_SEARCH_REQUEST: {
            const { instanceId } = action.payload;
            return {
                ...state,
                instances: {
                    ...state.instances,
                    [instanceId]: {
                        ...(state.instances[instanceId] || INIT_INSTANCE_STATE),
                        loading: true
                    }
                }
            };
        }

        case ACTIVITIES_TAB_SEARCH_RESULT: {
            const { entity, instanceId } = action.payload;
            const currentInstance = state.instances[instanceId] || INIT_INSTANCE_STATE;
            return {
                ...state,
                instances: {
                    ...state.instances,
                    [instanceId]: {
                        ...currentInstance,
                        loading: false,
                        [entity]: action.payload.oldNextToken
                            ? [...(currentInstance[entity] || []), ...action.payload.activities]
                            : action.payload.activities,
                        nextToken: action.payload?.nextToken
                    }
                }
            };
        }

        case ACTIVITIES_TAB_SEARCH_USERS_REQUEST:
            return { ...state, loadingUsers: true }

        case ACTIVITIES_TAB_SEARCH_USERS_RESULT:
            return { ...state, users: action.payload?.users || [], loadingUsers: false }

        case CLEAR_REDUX: {
            if (!["", "ACTIVITIES_TAB"].includes(action.payload.option)) {
                return state;
            }
            
            const { instanceId, parameters } = action.payload;
            
            if (instanceId && parameters) {
                // Clear specific instance with parameters
                return {
                    ...state,
                    instances: {
                        ...state.instances,
                        [instanceId]: {
                            ...(state.instances[instanceId] || INIT_INSTANCE_STATE),
                            ...parameters
                        }
                    }
                };
            } else if (instanceId) {
                // Clear specific instance completely
                const { [instanceId]: removed, ...remainingInstances } = state.instances;
                return {
                    ...state,
                    instances: remainingInstances
                };
            } else if (parameters) {
                // Clear global state with parameters
                return { ...state, ...parameters };
            } else {
                // Clear everything
                return { ...INIT_STATE };
            }
        }

        default:
            return state;
    }
};